import { TranslationKeys } from '~frontend-common/i18n/english/garage-subquestion.i18n';

const keys: TranslationKeys = {
  garage: {
    helper: {
      hasLivingSpace: 'Un garage habitable est chauffé avec espace de vie comme salle de bain et/ou cuisine.',
    },
    titles: {
      hasLivingSpace: 'Le garage est-il habitable?',
      numberOfCars: 'Combien de voitures le garage peut-il contenir?',
    },
  },
};

export default keys;
